var API_ENDPOINT_BASE = "https://cearaevt.tur.ar";
var COUNTRIES = [
  "Argentina",
  "Brasil",
  "Chile",
  "Uruguay",
  "Afganistán",
  "Albania",
  "Alemania",
  "Andorra",
  "Angola",
  "Anguila",
  "Antártida",
  "Antigua y Barbuda",
  "Arabia Saudí",
  "Argelia",
  "Armenia",
  "Aruba",
  "Australia",
  "Austria",
  "Azerbaiyán",
  "Bahamas",
  "Bangladés",
  "Barbados",
  "Baréin",
  "Bélgica",
  "Belice",
  "Benín",
  "Bermudas",
  "Bielorrusia",
  "Bolivia",
  "Bosnia y Herzegovina",
  "Botsuana",
  "Brunéi",
  "Bulgaria",
  "Burkina Faso",
  "Burundi",
  "Bután",
  "Cabo Verde",
  "Camboya",
  "Camerún",
  "Canadá",
  "Canarias",
  "Caribe neerlandés",
  "Catar",
  "Ceuta y Melilla",
  "Chad",
  "Chequia",
  "China",
  "Chipre",
  "Ciudad del Vaticano",
  "Colombia",
  "Comoras",
  "Corea del Norte",
  "Corea del Sur",
  "Costa Rica",
  "Côte d’Ivoire",
  "Croacia",
  "Cuba",
  "Curazao",
  "Diego García",
  "Dinamarca",
  "Dominica",
  "Ecuador",
  "Egipto",
  "El Salvador",
  "Emiratos Árabes Unidos",
  "Eritrea",
  "Eslovaquia",
  "Eslovenia",
  "España",
  "Estados Unidos",
  "Estonia",
  "Etiopía",
  "Eurozone",
  "Filipinas",
  "Finlandia",
  "Fiyi",
  "Francia",
  "Gabón",
  "Gambia",
  "Georgia",
  "Ghana",
  "Gibraltar",
  "Granada",
  "Grecia",
  "Groenlandia",
  "Guadalupe",
  "Guam",
  "Guatemala",
  "Guayana Francesa",
  "Guernesey",
  "Guinea",
  "Guinea Ecuatorial",
  "Guinea-Bisáu",
  "Guyana",
  "Haití",
  "Honduras",
  "Hungría",
  "India",
  "Indonesia",
  "Irak",
  "Irán",
  "Irlanda",
  "Isla de la Ascensión",
  "Isla de Man",
  "Isla de Navidad",
  "Isla Norfolk",
  "Islandia",
  "Islas Åland",
  "Islas Caimán",
  "Islas Cocos",
  "Islas Cook",
  "Islas Feroe",
  "Islas Georgia del Sur y Sandwich del Sur",
  "Islas Malvinas",
  "Islas Marianas del Norte",
  "Islas Marshall",
  "Islas menores alejadas de EE. UU.",
  "Islas Pitcairn",
  "Islas Salomón",
  "Islas Turcas y Caicos",
  "Islas Vírgenes Británicas",
  "Islas Vírgenes de EE. UU.",
  "Israel",
  "Italia",
  "Jamaica",
  "Japón",
  "Jersey",
  "Jordania",
  "Kazajistán",
  "Kenia",
  "Kirguistán",
  "Kiribati",
  "Kosovo",
  "Kuwait",
  "Laos",
  "Lesoto",
  "Letonia",
  "Líbano",
  "Liberia",
  "Libia",
  "Liechtenstein",
  "Lituania",
  "Luxemburgo",
  "Macedonia",
  "Madagascar",
  "Malasia",
  "Malaui",
  "Maldivas",
  "Mali",
  "Malta",
  "Marruecos",
  "Martinica",
  "Mauricio",
  "Mauritania",
  "Mayotte",
  "México",
  "Micronesia",
  "Moldavia",
  "Mónaco",
  "Mongolia",
  "Montenegro",
  "Montserrat",
  "Mozambique",
  "Myanmar (Birmania)",
  "Namibia",
  "Nauru",
  "Nepal",
  "Nicaragua",
  "Níger",
  "Nigeria",
  "Niue",
  "Noruega",
  "Nueva Caledonia",
  "Nueva Zelanda",
  "Omán",
  "Países Bajos",
  "Pakistán",
  "Palaos",
  "Panamá",
  "Papúa Nueva Guinea",
  "Paraguay",
  "Perú",
  "Polinesia Francesa",
  "Polonia",
  "Portugal",
  "Puerto Rico",
  "RAE de Hong Kong (China)",
  "RAE de Macao (China)",
  "Reino Unido",
  "República Centroafricana",
  "República del Congo",
  "República Democrática del Congo",
  "República Dominicana",
  "Reunión",
  "Ruanda",
  "Rumanía",
  "Rusia",
  "Sáhara Occidental",
  "Samoa",
  "Samoa Americana",
  "San Bartolomé",
  "San Cristóbal y Nieves",
  "San Marino",
  "San Martín",
  "San Pedro y Miquelón",
  "San Vicente y las Granadinas",
  "Santa Elena",
  "Santa Lucía",
  "Santo Tomé y Príncipe",
  "Senegal",
  "Serbia",
  "Seychelles",
  "Sierra Leona",
  "Singapur",
  "Sint Maarten",
  "Siria",
  "Somalia",
  "Sri Lanka",
  "Suazilandia",
  "Sudáfrica",
  "Sudán",
  "Sudán del Sur",
  "Suecia",
  "Suiza",
  "Surinam",
  "Svalbard y Jan Mayen",
  "Tailandia",
  "Taiwán",
  "Tanzania",
  "Tayikistán",
  "Territorio Británico del Océano Índico",
  "Territorios Australes Franceses",
  "Territorios Palestinos",
  "Timor-Leste",
  "Togo",
  "Tokelau",
  "Tonga",
  "Trinidad y Tobago",
  "Tristán de Acuña",
  "Túnez",
  "Turkmenistán",
  "Turquía",
  "Tuvalu",
  "Ucrania",
  "Uganda",
  "United Nations",
  "Uzbekistán",
  "Vanuatu",
  "Venezuela",
  "Vietnam",
  "Wallis y Futuna",
  "Yemen",
  "Yibuti",
  "Zambia",
  "Zimbabue",
];

export { API_ENDPOINT_BASE, COUNTRIES };
